import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getOnboardingByRequestForQuoteId, getOnboardingsByOrderId } from '../clients/supplierOnboarding.api';

export const supplierOnboarding = createQueryKeys('supplierOnboarding', {
    byOrderId: (orderId: string) => ({
        queryKey: [orderId],
        queryFn: () => getOnboardingsByOrderId(orderId),
    }),
    byRequestForQuoteId: (requestForQuoteId: string) => ({
        queryKey: [requestForQuoteId],
        queryFn: () => getOnboardingByRequestForQuoteId(requestForQuoteId),
    }),
});
